import { render, staticRenderFns } from "./ContactForProvider.vue?vue&type=template&id=0556d50e&scoped=true"
import script from "./ContactForProvider.vue?vue&type=script&lang=js"
export * from "./ContactForProvider.vue?vue&type=script&lang=js"
import style0 from "./ContactForProvider.vue?vue&type=style&index=0&id=0556d50e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0556d50e",
  null
  
)

export default component.exports